import axios from 'axios';
import { PMI_BASE_PATH } from './api-base-paths';

export const getAllPMI = (params = {}) => {
  try {
    return axios.get(`${PMI_BASE_PATH}/getAllPMI`, { params });
  } catch (error) {
    console.error('Error fetching all PMI', error);
  }
};

export const createPMI = (data) => {
  return axios.post(`${PMI_BASE_PATH}/createPMI`, data);
};

export const updatePMI = (id, data) => {
  return axios.put(`${PMI_BASE_PATH}/updatePMI/${id}`, data);
};

export const getPMIById = (id) => {
  return axios.get(`${PMI_BASE_PATH}/getPMIById/${id}`);
};

export const getAutoCertificateNo = () => {
  return axios.get(`${PMI_BASE_PATH}/getAutoCertificateNo`);
};

export const deletePMI = (id) => {
  return axios.put(`${PMI_BASE_PATH}/deletePMI/${id}`);
};

export const deletePMIDescription = (id) => {
  return axios.delete(`${PMI_BASE_PATH}/deletePMIDescription/${id}`);
};

export const getPrint = async () => {
  try {
    const response = await axios.get(`${PMI_BASE_PATH}/getPrint`);
    return response.data;
  } catch (error) {
    console.error('Error fetching PMI print:', error);
    throw error;
  }
};

export const getPMIPDF = (id) => {
  return axios.get(`${PMI_BASE_PATH}/getPMIPDF/${id}`);
};
